/** List downloads (Excel; no CSV since 2026-10-17): fetched with the session's token and saved under the name the server gives. */
import { toast } from "sonner";
import { downloadFile } from "@/lib/open-pdf";
import { errMsg } from "./hooks";

export type ExportParams = Record<string, string | number | undefined>;

export const withQuery = (path: string, p: ExportParams) => {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(p))
    if (v !== undefined && v !== "") s.set(k, String(v));
  const q = s.toString();
  return q ? `${path}?${q}` : path;
};

export async function downloadExport(
  path: string,
  p: ExportParams,
  fallbackName: string
) {
  try {
    await downloadFile(withQuery(path, p), fallbackName);
  } catch (e) {
    toast.error(errMsg(e));
  }
}
